export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL,
  ADJUNTOS_URL: process.env.REACT_APP_ADJUNTOS_URL || 'https://sugi.com.ar/Adjuntos',
  TIMEOUT: 300000,
  RETRY_ATTEMPTS: 3,
};

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};
